import InnerComponent from '@Components/Sales/Invoice/ViewInvoice';
import orgContainer from '@Components/AppContainer';

const ViewInvoice = () => ((orgContainer(InnerComponent)));
export default ViewInvoice;
